import styled from "styled-components"
import { Stack, Text } from "@quorumus/plum"

export const TitleSubtitleStack = styled(Stack)`
    text-align: center;
    width: 100%;
    gap: 8px;
    font-size: 16px;
`

export const BackgroundImage = styled.img`
    width: 100%;
    height: auto;
    border-radius: 4px;
    object-fit: cover;
    object-position: 50% 50%;
    margin-bottom: 12px; /* We already have 12px from TitleSubtitleStack gap */
    font-size: 16px;
`

export const Title = styled(Text)`
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.3;
    color: #000000;
`

export const Subtitle = styled.p`
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    margin: 0;
    width: 100%;
    font-size: 16px;
    margin-bottom: 0;

    p {
        margin: 0;
    }
`
